import { SealPill } from "@caint/design-system";
import { engine } from "../lib/engine.ts";
import type { VisitaEvolucao } from "../state/useAppState.ts";

function corDelta(d: number | null): string {
  if (d == null) {
    return "var(--text-muted)";
  }
  return d >= 0 ? "var(--success)" : "var(--danger)";
}

function textoDelta(d: number | null): string {
  if (d == null) {
    return "—";
  }
  return `${d >= 0 ? "▲" : "▼"} ${engine.pct(Math.abs(d))}`;
}

function VisitaLinha({ v, ultima }: { v: VisitaEvolucao; ultima: boolean }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: "9px 0",
        borderBottom: ultima ? undefined : "0.5px solid var(--border)",
      }}
    >
      <span style={{ flex: 1, fontWeight: v.atual ? 700 : 500 }}>
        {v.rotulo}
        {v.atual ? " · atual" : ""}
      </span>
      <SealPill chave={v.selo} />
      <b style={{ fontFamily: "var(--font-mono)", minWidth: 52, textAlign: "right" }}>{engine.pct(v.imgq)}</b>
      <span
        style={{
          minWidth: 66,
          textAlign: "right",
          fontFamily: "var(--font-mono)",
          fontSize: 12.5,
          color: corDelta(v.delta),
        }}
      >
        {textoDelta(v.delta)}
      </span>
    </div>
  );
}

/**
 * Painel de evolução entre visitas (ciclos) da unidade: IMGQ de cada ciclo,
 * selo e variação (delta) vs a visita anterior. Some com menos de 2 ciclos.
 */
export function EvolucaoVisitas({ evolucao }: { evolucao: VisitaEvolucao[] }) {
  if (evolucao.length < 2) {
    return null;
  }
  return (
    <div style={{ marginTop: 16 }}>
      <h3 style={{ fontSize: 13, color: "var(--text-muted)", margin: "0 0 8px" }}>Evolução entre visitas</h3>
      <div
        style={{
          border: "0.5px solid var(--border)",
          borderRadius: 12,
          padding: "2px 14px",
          background: "var(--surface)",
        }}
      >
        {evolucao.map((v, i) => (
          <VisitaLinha key={v.id} v={v} ultima={i === evolucao.length - 1} />
        ))}
      </div>
    </div>
  );
}
